import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import TKTaxi from "components/Thongke/Vantaihanhkhach/TKTaxi.js";
//import TKXedulich from "components/Thongke/Vantaihanhkhach/TKXedulich.js";
import TKXehopdong from "components/Thongke/Vantaihanhkhach/TKXehopdong.js";
import TKXetuyencodinh from "components/Thongke/Vantaihanhkhach/TKXetuyencodinh.js";
import TKXebuyt from "components/Thongke/Vantaihanhkhach/TKXebuyt.js";
export default function TKVantaihanhkhach() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Taxi",
            tabContent: <TKTaxi />,
          },
          {
            tabName: "Xe hợp đồng",
            tabContent: <TKXehopdong />,
          },
          {
            tabName: "Xe tuyến cố định",
            tabContent: <TKXetuyencodinh />,
          },
          {
            tabName: "Xe buýt",
            tabContent: <TKXebuyt />,
          },
        ]}
      />
    </div>
  );
}
